/**
 * PreviewIt Widget Bundle
 * Generated: 2025-12-10T12:36:52.453Z
 * Widgets: 1
 * 
 * Upload this file to your Shopify theme: Assets > Add a new asset
 * Then add the template snippet to your product pages.
 */
(function() {
  'use strict';

  // ============================================
  // WIDGET CONFIGURATIONS
  // ============================================
  var WIDGETS = [
  {
    "id": "a2417a4f-84e5-483a-9874-88282f2bf91e",
    "name": "lake-life-preview",
    "urlTemplate": "https://renders.welltoldco.com/v2?productLine=LakeLife&productType={product_type}&location={lake_value},{lake_label},{state},{style}&index={index}",
    "fallbackImage": null,
    "imageIndices": "1",
    "inputs": [
      {
        "id": "location_name",
        "type": "text",
        "label": "Location Name",
        "defaultValue": "Please Select a Lake",
        "options": [],
        "source": {
          "type": "static",
          "regexPattern": ",.*$"
        }
      },
      {
        "id": "state",
        "type": "text",
        "label": "State/Region",
        "defaultValue": "",
        "options": [],
        "source": {
            "type": "dom",
            "selector": 'input[name="properties[State]"]',
            "attribute": "value"
        }
      },
      {
        "id": "style",
        "type": "text",
        "label": "Map Style",
        "defaultValue": "",
        "source": {
            "type": "dom",
            "selector": 'input[type="radio"][name="name0"]:checked',
            "attribute": "value"
        }
      },
      {
        "id": "product_type",
        "type": "hidden",
        "label": "Product Type",
        "defaultValue": "Rocks",
        "source": {
          "type": "liquid",
          "regexPattern": "(Rocks) Glass|(Pint) Glass|(Stemless Wine) Glass|(Stemmed Wine) Glass",
          "regexReplacement": "$1$2$3$4"
        }
      },
      {
        "id": "product_id",
        "type": "hidden",
        "label": "Product ID (Hidden)",
        "defaultValue": "",
        "options": [],
        "source": {
          "type": "static"
        }
      },
      {
        "id": "lake_value",
        "type": "hidden",
        "label": "Lake Value",
        "defaultValue": "",
        "options": [],
        "source": {
          "type": "dom",
          "selector": ".wt-option-autocomplete",
          "attribute": "data-value"
        }
      },
      {
        "id": "lake_label",
        "type": "hidden",
        "label": "Lake Label",
        "defaultValue": "Please Select a Lake",
        "options": [],
        "source": {
          "type": "dom",
          "selector": ".wt-option-autocomplete",
          "attribute": "data-label",
          "regexPattern": ",.*$"
        }
      }
    ]
  }
];

  // Create lookup maps
  var widgetById = {};
  var widgetByName = {};
  WIDGETS.forEach(function(w) {
    widgetById[w.id] = w;
    widgetByName[w.name.toLowerCase().replace(/\s+/g, '-')] = w;
  });

  // ============================================
  // UTILITY FUNCTIONS
  // ============================================
  
  function transform(val, pattern, flags, replacement) {
    if (!pattern || !val) return val;
    try {
      var regex = new RegExp(pattern, flags || '');
      return String(val).replace(regex, replacement || '');
    } catch (e) {
      console.warn('[PreviewIt] Invalid regex:', pattern, e);
      return val;
    }
  }

  function getVal(selector, attr, fallback) {
    
    var el = document.querySelector(selector);
    if (!el) {
      console.warn('[PreviewIt] Element not found:', selector);
      return fallback;
    }
    var val;
    if (attr === 'value') val = el.value;
    else if (attr === 'text') val = (el.textContent || '').trim();
    else if (attr.indexOf('data-') === 0) {
      var dataKey = attr.replace('data-', '').replace(/-([a-z])/g, function(g) { return g[1].toUpperCase(); });
      val = el.dataset[dataKey];
    }
    else val = el.getAttribute(attr);
    
    return val || fallback;
  }

  function getSelectedColor() {
  // Most specific: BCPO option block shown in your screenshot
  var el =
    document.querySelector('#bcpo-select-option-1 input[type="radio"]:checked') ||
    document.querySelector('input[type="radio"][name="name1"]:checked');

  return el && el.value ? String(el.value).trim() : '';
}


  function getInputValue(input, container) {
    var source = input.source || { type: 'static' };
    var val = input.defaultValue || '';

    if (source.type === 'dom' && source.selector) {
      val = getVal(source.selector, source.attribute || 'value', input.defaultValue || '');
    } else if (source.type === 'liquid' && container) {
      var kebabId = input.id.toLowerCase().replace(/_/g, '-');
      var attrName = 'data-previewit-' + kebabId;
      val = container.getAttribute(attrName) || input.defaultValue || '';
    }

    if (source.regexPattern) {
      val = transform(val, source.regexPattern, source.regexFlags || '', source.regexReplacement || '');
    }

    return val;
  }

  // ============================================
  // MODAL COMPONENT
  // ============================================

  function createModal(widget, inputValues) {
    var indices = (widget.imageIndices || '1').split(',').map(function(s) { return s.trim(); }).filter(function(s) { return s; });
    var currentIndex = 0;

    function buildUrl(idx) {
      var url = widget.urlTemplate;
      widget.inputs.forEach(function(input) {
        var val = inputValues[input.id] || input.defaultValue || '';
        url = url.replace(new RegExp('\\{' + input.id + '\\}', 'g'), encodeURIComponent(val));
      });
      url = url.replace(/\{index\}/g, encodeURIComponent(indices[idx] || '1'));
      return url;
    }

    var overlay = document.createElement('div');
    overlay.className = 'previewit-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:99999;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 0.2s;';

    var modal = document.createElement('div');
    modal.className = 'previewit-modal';
    modal.style.cssText = 'background:#fff;border-radius:12px;max-width:90vw;max-height:90vh;width:600px;overflow:hidden;position:relative;box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);';

    var header = document.createElement('div');
    header.style.cssText = 'padding:16px 20px;border-bottom:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center;';
    header.innerHTML = '<h2 style="margin:0;font-size:18px;font-weight:600;">Product Design Preview</h2>';

    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'background:none;border:none;font-size:24px;cursor:pointer;color:#6b7280;line-height:1;padding:0;';
    closeBtn.onclick = function() { closeModal(); };
    header.appendChild(closeBtn);

    var imgContainer = document.createElement('div');
    imgContainer.style.cssText = 'position:relative;aspect-ratio:1;background:#f3f4f6;display:flex;align-items:center;justify-content:center;';

    var img = document.createElement('img');
    img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;display:none;';
    img.alt = 'Preview';

    var loader = document.createElement('div');
    loader.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.8);';
    loader.innerHTML = '<div style="width:40px;height:40px;border:3px solid #e5e7eb;border-top-color:#2563eb;border-radius:50%;animation:previewit-spin 1s linear infinite;"></div>';

    imgContainer.appendChild(loader);
    imgContainer.appendChild(img);

    function loadImage(idx) {
      loader.style.display = 'flex';
      img.style.display = 'none';
      img.style.opacity = '0.5';

      var url = buildUrl(idx);
      var testImg = new Image();

      testImg.onload = function() {
        img.src = url;
        img.style.display = 'block';
        img.style.opacity = '1';
        loader.style.display = 'none';
      };

      testImg.onerror = function() {
        img.src = widget.fallbackImage ||
          'data:image/svg+xml,' +
          encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="400" height="250">
              <rect width="100%" height="100%" fill="#f3f4f6"/>
              <text x="50%" y="40%" text-anchor="middle" fill="#9ca3af" font-size="18">
                Preview Unavailable
              </text>
              <text x="50%" y="60%" text-anchor="middle" fill="#9ca3af" font-size="14">
                Please select all options.
              </text>
            </svg>
          `);

        img.style.display = 'block';
        img.style.opacity = '1';
        loader.style.display = 'none';
      };

      testImg.src = url;
    }

    modal.appendChild(header);
    modal.appendChild(imgContainer);
    overlay.appendChild(modal);

    function closeModal() {
      overlay.style.opacity = '0';
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 200);
    }

    overlay.onclick = function(e) {
      if (e.target === overlay) closeModal();
    };

    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', onEsc);
      }
    });

    document.body.appendChild(overlay);
    setTimeout(function() { overlay.style.opacity = '1'; }, 10);
    loadImage(0);
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function initWidget(container) {
    var widgetId = container.dataset.previewitWidget;
    var widgetName = container.dataset.previewitName;

    var widget = widgetById[widgetId] || widgetByName[(widgetName || '').toLowerCase().replace(/\s+/g, '-')];
    if (!widget) return;

    var triggerBtn = container.querySelector('[data-previewit-trigger]');
    if (!triggerBtn) return;

    triggerBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var inputValues = {};
      widget.inputs.forEach(function(input) {
        inputValues[input.id] = getInputValue(input, container);
      });
        // Prepend Color to product_type (only if Color exists)
  var color = getSelectedColor(); // '' if not selected
  var baseType = (inputValues.product_type || '').trim();

  if (color && baseType) {
    inputValues.product_type = color + ' ' + baseType; // space becomes %20 via encodeURIComponent
  } else {
    inputValues.product_type = baseType; // no leading space if no color
  }

  createModal(widget, inputValues);

    });
  }

  function init() {
    var style = document.createElement('style');
    style.textContent = '@keyframes previewit-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);

    var containers = document.querySelectorAll('[data-previewit-widget], [data-previewit-name]');
    containers.forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
